import { render } from "./PostSectionSelectionPreviewComponent.vue?vue&type=template&id=4f24a4fa&scoped=true&ts=true"
import script from "./PostSectionSelectionPreviewComponent.vue?vue&type=script&lang=ts"
export * from "./PostSectionSelectionPreviewComponent.vue?vue&type=script&lang=ts"

import "./PostSectionSelectionPreviewComponent.vue?vue&type=style&index=0&id=4f24a4fa&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f24a4fa"]])

export default __exports__